import React, { createContext, useContext, useState, useEffect } from 'react';

interface GuideContextType {
  guideEnabled: boolean;
  toggleGuide: () => void;
}

const GuideContext = createContext<GuideContextType>({
  guideEnabled: true,
  toggleGuide: () => {},
});

export const useGuide = () => useContext(GuideContext);

const STORAGE_KEY = 'lr_guide_enabled';

export const GuideProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [guideEnabled, setGuideEnabled] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored !== null) return stored === 'true';
    } catch {}
    return true; // on by default for all users
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, String(guideEnabled));
    } catch {}
  }, [guideEnabled]);

  const toggleGuide = () => setGuideEnabled(prev => !prev);

  return (
    <GuideContext.Provider value={{ guideEnabled, toggleGuide }}>
      {children}
    </GuideContext.Provider>
  );
};
